import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { advanceParamCheck } from '../../utils';

export interface TradePayOptions {
    tradeNO: string;
    orderStr: string;
    sign: string;
    extendParam?: string;
    invalidParamObj?: any;
}

const nonemptyParam = { nonempty: true }; // 非空参数
const optionalParam = { optional: true }; // 可选参数

// 快速接入支付
export function tradePay(option: TradePayOptions) {
    if (
        advanceParamCheck(
            APINames.Native.TRADE_PAY,
            option,
            { tradeNO: '', orderStr: '', sign: '', extendParam: '' },
            { tradeNO: nonemptyParam, orderStr: nonemptyParam, sign: nonemptyParam, extendParam: optionalParam }
        )
    ) {
        return MacleJSBridge.beforeInvoke(APINames.Native.TRADE_PAY, option);
    }
    return option.invalidParamObj;
}
